import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Spinner from "components/common/Spinner";
import {
    fetchApiLogItem
} from "actions/apiInfoActions";

class LogsItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            log: false
        };

        this.props.fetchApiLogItem(this.props.match.params.name, (response) => {
            this.setState({
                log: response
            });
        });
    }

    downloadLog = () => {
        const { log } = this.state;
        const { name } = this.props.match.params;
        
        if (log) {
            const blob = new Blob([log], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${name}.log`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }

    render () {
        const {
            loading
        } = this.props;
        const {
            log
        } = this.state;

        return (
            <div>
                <div className="d-flex align-items-center mb-3">
                    <h1 className="mb-0 me-3">Log: {this.props.match.params.name}</h1>
                    {log && (
                        <button 
                            className="btn btn-primary btn-sm"
                            onClick={this.downloadLog}
                            title="Download log file"
                        >
                            <i className="fas fa-download me-1"></i>
                            Download
                        </button>
                    )}
                </div>
                {!loading || <Spinner />}
                {!log ||
                    <div className="card card-body mb-5">
                        <pre>
                            {log}
                        </pre>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.globalFormErrors.loading
});

const mapStateToDispatch = dispatch => ({
    fetchApiLogItem: bindActionCreators(fetchApiLogItem, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(LogsItem);
